"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _TimelineActions = _interopRequireDefault(require("crm_ui/timeline/data/actions/TimelineActions"));

var _TimelineTeamsFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineTeamsFilterDependency"));

var _TimelineUsersFilterDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineUsersFilterDependency"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _loggers = require("customer-data-tracking/loggers");

var _generalStore = require("general-store");

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TimelineFilterTeams = _interopRequireDefault(require("./TimelineFilterTeams"));

var _TimelineFilterUsers = _interopRequireDefault(require("./TimelineFilterUsers"));

var _TimelineClearFiltersButton = _interopRequireDefault(require("crm_ui/timeline/components/filter/TimelineClearFiltersButton"));

var TEAMS = 'TEAMS';
var USERS = 'USERS';

var TimelineAdvancedFilters =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TimelineAdvancedFilters, _React$Component);

  function TimelineAdvancedFilters(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineAdvancedFilters);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineAdvancedFilters).call(this, props));

    _this.handleUsersOpenChange = function () {
      _this.setState(function (state) {
        return {
          isUsersFilterOpen: !state.isUsersFilterOpen
        };
      });
    };

    _this.handleUserChange = function (_ref) {
      var value = _ref.target.value;
      var subAction = value.length > _this.props.selectedUsers.size ? 'added' : 'removed';

      _loggers.CrmLogger.logRecordInteraction(_this.props.objectType, {
        action: 'filter timeline by user',
        subAction: subAction
      });

      _this.handleUpdateTimelineUserAndTeamFilters(USERS, (0, _immutable.fromJS)(value));
    };

    _this.handleTeamsOpenChange = function () {
      _this.setState(function (state) {
        return {
          isTeamsFilterOpen: !state.isTeamsFilterOpen
        };
      });
    };

    _this.handleTeamChange = function (_ref2) {
      var value = _ref2.target.value;
      var subAction = value.size > _this.props.selectedTeams.size ? 'added' : 'removed';

      _loggers.CrmLogger.logRecordInteraction(_this.props.objectType, {
        action: 'filter timeline by team',
        subAction: subAction
      });

      _this.handleUpdateTimelineUserAndTeamFilters(TEAMS, value);
    };

    _this.state = {
      isUsersFilterOpen: false,
      isTeamsFilterOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(TimelineAdvancedFilters, [{
    key: "handleUpdateTimelineUserAndTeamFilters",
    value: function handleUpdateTimelineUserAndTeamFilters(filterType, selectedIds) {
      var updatedFilters = (0, _immutable.Map)({
        selectedTeams: filterType === TEAMS ? selectedIds : this.props.selectedTeams,
        selectedUsers: filterType === USERS ? selectedIds : this.props.selectedUsers
      });
      var _this$props = this.props,
          dateRange = _this$props.dateRange,
          objectType = _this$props.objectType,
          subjectId = _this$props.subjectId,
          timelineFavoriteEvents = _this$props.timelineFavoriteEvents,
          searchText = _this$props.searchText;
      var requestPayload = (0, _immutable.Map)({
        eventOptions: timelineFavoriteEvents,
        fromDate: dateRange.get('fromDate'),
        now: dateRange.get('now'),
        objectType: objectType,
        subjectId: subjectId,
        searchText: searchText
      }).merge(updatedFilters);

      _TimelineActions.default.updateTimelineUserAndTeamFilters(objectType, timelineFavoriteEvents, requestPayload);
    }
  }, {
    key: "render",
    value: function render() {
      var shouldRenderClear = Boolean(this.props.selectedTeams.size || this.props.selectedUsers.size);
      return _react.default.createElement("div", {
        className: "flex-row"
      }, _react.default.createElement(_TimelineFilterUsers.default, {
        handleUserOpenChange: this.handleUsersOpenChange,
        isUserFilterOpen: this.state.isUsersFilterOpen,
        onChange: this.handleUserChange,
        value: this.props.selectedUsers
      }), _react.default.createElement(_TimelineFilterTeams.default, {
        handleTeamOpenChange: this.handleTeamsOpenChange,
        isTeamFilterOpen: this.state.isTeamsFilterOpen,
        onChange: this.handleTeamChange,
        value: this.props.selectedTeams
      }), shouldRenderClear && _react.default.createElement(_TimelineClearFiltersButton.default, {
        onResetFilters: this.props.onResetFilters
      }));
    }
  }]);
  return TimelineAdvancedFilters;
}(_react.default.Component);

TimelineAdvancedFilters.propTypes = {
  dateRange: _propTypes.default.instanceOf(_immutable.Map),
  objectType: _ObjectTypesType.default.isRequired,
  onResetFilters: _propTypes.default.func.isRequired,
  searchText: _propTypes.default.string,
  subjectId: _propTypes.default.string.isRequired,
  timelineFavoriteEvents: _propTypes.default.instanceOf(_immutable.List),
  // general store deps
  selectedTeams: _propTypes.default.instanceOf(_immutable.List),
  selectedUsers: _propTypes.default.instanceOf(_immutable.List)
};

var _default = (0, _generalStore.connect)({
  selectedTeams: _TimelineTeamsFilterDependency.default,
  selectedUsers: _TimelineUsersFilterDependency.default
})(TimelineAdvancedFilters);

exports.default = _default;
module.exports = exports.default;